import { Link } from 'react-router-dom';
import EmptyState from '@/components/ui/EmptyState';
import type { FixtureBriefProps } from './types';

export default function FixtureBrief({ fixtures, emptyTitle = 'No upcoming fixtures' }: FixtureBriefProps) {
  const fixture = fixtures[0];
  if (!fixture) return <EmptyState title={emptyTitle} className="py-10" />;

  return (
    <Link
      to={`/matches/${fixture.id}`}
      aria-label={`${fixture.opponent}, ${fixture.competition}`}
      className="flex min-h-11 min-w-0 flex-col justify-center rounded-xl bg-white p-4 ring-1 ring-gray-200 transition-colors hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-blue-500 motion-reduce:transition-none dark:bg-gray-900 dark:ring-gray-800 dark:hover:bg-gray-800 sm:flex-row sm:items-center sm:justify-between sm:gap-4"
    >
      <span className="min-w-0">
        <span className="block break-words text-base font-semibold text-club-navy-950 dark:text-white">{fixture.opponent}</span>
        <span className="mt-1 block break-words text-sm text-gray-600 dark:text-gray-400">{fixture.competition} - {fixture.venue}</span>
      </span>
      <span className="mt-2 shrink-0 text-sm font-medium tabular-nums text-gray-700 dark:text-gray-200 sm:mt-0">
        <time dateTime={fixture.kickoffAt}>{fixture.kickoffAt}</time>
      </span>
    </Link>
  );
}
